import { useState } from 'react';
import PartialLoader from 'components/layout/PartialLoader';
import clsx from 'clsx';
import styles from './AgreementModal.module.scss';
import ConsentModal from '../../../../core/views/JoinPage/SignUpPage/Modals/ConsentModal';

const agreementModal = ({
  isModelOpen,
  setIsOpen,
  handleClose,
  setIsAgree,
  isAgree,
  checkboxText,
  text,
  loading,
}) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isFullScreenActive, setIsFullScreenActive] = useState(false);

  const handleScroll = (e) => {
    const { target } = e;

    if (target.scrollHeight <= Math.ceil(target.scrollTop) + target.offsetHeight) {
      setIsScrolled(true);
    }
  };

  return (
    <ConsentModal
      isModelOpen={isModelOpen}
      setIsOpen={setIsOpen}
      handleClose={handleClose}
      setIsAgree={setIsAgree}
      isAgree={isAgree}
      checkboxText={checkboxText}
      isShouldScroll
      isScrolled={isScrolled}
      isFullScreenActive={isFullScreenActive}
      setIsFullScreenActive={setIsFullScreenActive}
      isFullScreen
    >
      <div
        className={clsx(
          styles.contentFirstWrapper,
          isFullScreenActive ? styles.fullScreenContentWrapper : ''
        )}
      >
        <div className={styles.contentSecondWrapper}>
          <PartialLoader loading={loading} />
          <div onScroll={handleScroll}>
            <pre className={styles.text}>
              <div dangerouslySetInnerHTML={{ __html: text }} />
            </pre>
          </div>
        </div>
      </div>
    </ConsentModal>
  );
};

export default agreementModal;
